import { Controller } from "stimulus"
import 'select2'
import 'select2/dist/css/select2.css'
import { get } from "@rails/request.js";
import "tom-select/dist/css/tom-select.css"
import TomSelect from "tom-select"

export default class extends Controller {
  static targets = ['form', 'languageSelector', 'languageSelectorForm']

  connect() {
    if (this.hasLanguageSelectorTarget) {
      $(this.languageSelectorTarget).select2();
      $(this.languageSelectorTarget).on('select2:select select2:unselect', function () {
        let event = new Event('change', { bubbles: true }) // fire a native event
        this.dispatchEvent(event);
      });
    }
    $('.select2').select2();
    
  }

  makeSnapshot(e) {
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: `${this.formTarget.action}/make_answers_snapshot`,
      data: $(this.formTarget).serialize()
    });
  }

  changeLanguage(e) {
    e.preventDefault();
    this.languageSelectorFormTarget.submit();
  }

  toggleAutosend({ target }) {
    const autosendFields = document.querySelectorAll('.autoreport-fields');
    autosendFields.forEach(target => {
      target.classList.toggle('d-none');
    })
  }

  toggleDemographics({ target }) {
    const demographicFields = document.querySelectorAll('.demographic-fields');
    demographicFields.forEach(target => {
      target.classList.toggle('d-none');
    })
  }

  changeSurvey(event) {
    if (event.target.value) {
      get(`${event.target.baseURI}/select_language?survey_id=${event.target.value}`, {
        responseKind: "turbo-stream"
      })
    } else {
      document.getElementById('languages-selector-wrapper').innerHTML = ''
    }
  }
}
